"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _normalize = _interopRequireDefault(require("polished/lib/mixins/normalize"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/**
 * CssBaseline component is used to kickstart an elegant, consistent, and simple baseline to build upon
 */
var CssBaseline = function CssBaseline(props) {
  var className = props.className;
  return (0, _core.jsx)(_core.Global, {
    styles: [(0, _normalize.default)(), className]
  });
};

var _default = CssBaseline;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CssBaseline, "CssBaseline", "/builds/bA1zbJom/0/gojob/ui-bits/src/CssBaseline/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/CssBaseline/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Dc3NCYXNlbGluZS9pbmRleC50c3giXSwibmFtZXMiOlsiQ3NzQmFzZWxpbmUiLCJwcm9wcyIsImNsYXNzTmFtZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRUE7O0FBQ0E7Ozs7Ozs7Ozs7O0FBTUE7OztBQUdBLElBQU1BLFdBQWdELEdBQUcsU0FBbkRBLFdBQW1ELENBQUNDLEtBQUQsRUFBVztBQUFBLE1BQzFEQyxTQUQwRCxHQUM1Q0QsS0FENEMsQ0FDMURDLFNBRDBEO0FBR2xFLFNBQU8sZUFBQyxZQUFEO0FBQVEsSUFBQSxNQUFNLEVBQUUsQ0FBQyx5QkFBRCxFQUFjQSxTQUFkO0FBQWhCLElBQVA7QUFDRCxDQUpEOztlQU1lRixXOzs7Ozs7Ozs7Ozs7MEJBTlRBLFciLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IEdsb2JhbCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuaW1wb3J0IG5vcm1hbGl6ZSBmcm9tICdwb2xpc2hlZC9saWIvbWl4aW5zL25vcm1hbGl6ZSc7XG5cbmV4cG9ydCB0eXBlIENzc0Jhc2VsaW5lUHJvcHMgPSB7XG4gIGNsYXNzTmFtZT86IHN0cmluZztcbn07XG5cbi8qKlxuICogQ3NzQmFzZWxpbmUgY29tcG9uZW50IGlzIHVzZWQgdG8ga2lja3N0YXJ0IGFuIGVsZWdhbnQsIGNvbnNpc3RlbnQsIGFuZCBzaW1wbGUgYmFzZWxpbmUgdG8gYnVpbGQgdXBvblxuICovXG5jb25zdCBDc3NCYXNlbGluZTogRnVuY3Rpb25Db21wb25lbnQ8Q3NzQmFzZWxpbmVQcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyBjbGFzc05hbWUgfSA9IHByb3BzO1xuXG4gIHJldHVybiA8R2xvYmFsIHN0eWxlcz17W25vcm1hbGl6ZSgpLCBjbGFzc05hbWVdfSAvPjtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENzc0Jhc2VsaW5lO1xuIl19